/* unplugin-vue-components disabled */import script from "./GoodsOrderDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./GoodsOrderDetails.vue?vue&type=script&setup=true&lang=js"

import "./GoodsOrderDetails.vue?vue&type=style&index=0&id=eb721f0e&lang=scss"

const __exports__ = script;

export default __exports__